import { Power1 } from "gsap"
import Part1Sprite from "@assets/images/workflow/Exo_Diagram_Part01_sprite-90.png"
import Part2Sprite from "@assets/images/workflow/Exo_Diagram_Part02_sprite-90.png"
import Part3Sprite from "@assets/images/workflow/Exo_Diagram_Part03_sprite-90.png"
import Part4Sprite from "@assets/images/workflow/Exo_Diagram_Part04_sprite-90.png"

export const FPS_INTERVAL = 1000 / 60

const FRAME_HEIGHT = 300
const FRAME_WIDTH = 300

export const SPRITE_PATHS = [Part1Sprite, Part2Sprite, Part3Sprite, Part4Sprite]
export const SPRITE_SETTINGS = [
  {
    totalFrames: 90,
    frameWidth: FRAME_WIDTH,
    frameHeight: FRAME_HEIGHT,
    numRows: 1,
    numCols: 90
  },
  {
    totalFrames: 90,
    frameWidth: FRAME_WIDTH,
    frameHeight: FRAME_HEIGHT,
    numRows: 1,
    numCols: 90
  },
  {
    totalFrames: 90,
    frameWidth: FRAME_WIDTH,
    frameHeight: FRAME_HEIGHT,
    numRows: 1,
    numCols: 90
  },
  {
    totalFrames: 90,
    frameWidth: FRAME_WIDTH,
    frameHeight: FRAME_HEIGHT,
    numRows: 1,
    numCols: 90
  }
]

/**
 *
 * @param {*} settings
    context: CanvasRenderingContext2D;
    targetFrameIndex: number;
    spriteImg: HTMLImageElement;
    spriteSettings: {
      totalFrames: number;
      frameWidth: number;
      frameHeight: number;
      numRows: number;
      numCols: number;
    };
 * @returns
 */
export function setSpriteOnCanvas(settings) {
  const { context, spriteImg } = settings
  const { totalFrames, frameWidth, frameHeight, numRows, numCols } = settings.spriteSettings
  let { targetFrameIndex } = settings

  // Calculated fields
  const maxFrameIndex = totalFrames - 1
  if (targetFrameIndex > maxFrameIndex) {
    targetFrameIndex = maxFrameIndex
  } else if (targetFrameIndex < 0) {
    targetFrameIndex = 0
  }

  const framesPerSprite = numRows * numCols
  const frameIndexInSprite = targetFrameIndex % framesPerSprite

  const rowIndex = Math.floor(frameIndexInSprite / numCols)
  const colIndex = frameIndexInSprite % numCols
  context.clearRect(0, 0, frameWidth, frameHeight)
  return context.drawImage(
    spriteImg,
    colIndex * frameWidth,
    rowIndex * frameHeight,
    frameWidth,
    frameHeight,
    0,
    0,
    frameWidth,
    frameHeight
  )
}

export const animationBaseDuration = 0.666
const anticipateStepOffset = 0.015
export const TRIGGER_POINTS = [
  0, // INITIAL STATE
  0.001, // STEP 1
  0.25 - anticipateStepOffset, // STEP 2
  0.5 - anticipateStepOffset, // STEP 3
  0.75 - anticipateStepOffset, // STEP 4
  1 - anticipateStepOffset // STEP 5 : All Complete
]

export function getTargetScrollValues(
  currentStepNumber,
  targetStepNumber,
  scrollTriggerStart,
  scrollTriggerEnd
) {
  const span = scrollTriggerEnd - scrollTriggerStart
  const offset = span * TRIGGER_POINTS[targetStepNumber]
  const target = scrollTriggerStart + offset
  const stepSpan = Math.abs(targetStepNumber - currentStepNumber)
  const result = {
    duration: stepSpan > 1 ? animationBaseDuration * 1.5 : animationBaseDuration,
    scrollTo: target,
    ease: Power1.easeOut
  }
  return result
}

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  }
}

export function describeArc(x, y, radius, startAngle, endAngle) {
  const start = polarToCartesian(x, y, radius, endAngle)
  const end = polarToCartesian(x, y, radius, startAngle)

  const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1"

  const d = ["M", start.x, start.y, "A", radius, radius, 0, 0, 0, end.x, end.y].join(" ")
  return d
}

export function lockPageScroll() {
  document.body.style.setProperty("overflow", "hidden")
}
export function unlockPageScroll() {
  document.body.style.setProperty("overflow", "auto")
}
